/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LanguageDto } from '../models/LanguageDto';
import type { SiteEmployeeStudyDto } from '../models/SiteEmployeeStudyDto';
import type { SiteSearchParametersDto } from '../models/SiteSearchParametersDto';
import type { StudyBaseInfoDto } from '../models/StudyBaseInfoDto';
import type { StudyDto } from '../models/StudyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class StudyService {

    /**
     * Get the languages of studies
     * @returns LanguageDto
     * @throws ApiError
     */
    public static studyControllerGetStudiesLanguages(): CancelablePromise<Array<LanguageDto>> {
        return __request({
            method: 'GET',
            path: `/study/languages`,
        });
    }

    /**
     * Get site employee studies
     * @param siteId
     * @param employeeId
     * @returns SiteEmployeeStudyDto
     * @throws ApiError
     */
    public static studyControllerGetSiteEmployeeStudies(
        siteId: string,
        employeeId: string,
    ): CancelablePromise<Array<SiteEmployeeStudyDto>> {
        return __request({
            method: 'GET',
            path: `/study/siteEmployeeStudy`,
            query: {
                'siteId': siteId,
                'employeeId': employeeId,
            },
        });
    }

    /**
     * Search studies
     * @param requestBody
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerSearchAll(
        requestBody: SiteSearchParametersDto,
    ): CancelablePromise<Array<StudyDto>> {
        return __request({
            method: 'PUT',
            path: `/study/search/all`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Search studies
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerGetArSubs(): CancelablePromise<Array<StudyDto>> {
        return __request({
            method: 'GET',
            path: `/study/getArSubs/all`,
        });
    }

    /**
     * Get studies
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerList(): CancelablePromise<Array<StudyDto>> {
        return __request({
            method: 'GET',
            path: `/study`,
        });
    }

    /**
     * Get list of studies
     * @returns StudyBaseInfoDto
     * @throws ApiError
     */
    public static studyControllerStudyFitlerList(): CancelablePromise<Array<StudyBaseInfoDto>> {
        return __request({
            method: 'GET',
            path: `/study/list`,
        });
    }

    /**
     * Get current user studies
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerCurrentUserStudies(): CancelablePromise<Array<StudyDto>> {
        return __request({
            method: 'GET',
            path: `/study/my`,
        });
    }

    /**
     * Get current user studies for filter
     * @param email
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerCurrentUserStudiesForFilter(
        email: string,
    ): CancelablePromise<Array<StudyDto>> {
        return __request({
            method: 'GET',
            path: `/study/spm-studies/${email}`,
        });
    }

    /**
     * Get study
     * @param id
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerGet(
        id: string,
    ): CancelablePromise<StudyDto> {
        return __request({
            method: 'GET',
            path: `/study/${id}`,
        });
    }

    /**
     * Get the list of spm unassigned studies
     * @param id
     * @returns StudyDto
     * @throws ApiError
     */
    public static studyControllerSpmStudyList(
        id: string,
    ): CancelablePromise<Array<StudyDto>> {
        return __request({
            method: 'GET',
            path: `/study/spmStudyList/${id}`,
        });
    }

}